const parisFormatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Europe/Paris", year: "numeric", month: "2-digit", day: "2-digit",
});

export function parisDate(now = new Date()) {
  const parts = Object.fromEntries(parisFormatter.formatToParts(now).map(p => [p.type, p.value]));
  return `${parts.year}-${parts.month}-${parts.day}`;
}

// Dates civiles manipulées en UTC : jamais converties depuis le fuseau du navigateur.
export function calendarDays(today, workDays, blocked, count = 42) {
  const start = new Date(`${today}T12:00:00Z`);
  return Array.from({ length: count }, (_, offset) => {
    const d = new Date(start); d.setUTCDate(start.getUTCDate() + offset);
    const key = d.toISOString().slice(0, 10), dow = (d.getUTCDay() + 6) % 7;
    return { key, d, dow, open: key > today && workDays.includes(dow) && !blocked.includes(key) };
  });
}

export function millisecondsToParisMidnight(now = new Date()) {
  const today = parisDate(now);
  let low = now.getTime(), high = low + 26 * 60 * 60 * 1000;
  while (high - low > 1) {
    const mid = Math.floor((low + high) / 2);
    if (parisDate(new Date(mid)) === today) low = mid; else high = mid;
  }
  return Math.max(1, high - now.getTime());
}
